export default __webpack_public_path__ + "19c893a347280e887cbd8a9e23c48668.woff2";